


























import store from '@/store';
import { getContentArea } from '@/contentful';
import {
  LoadingService,
  ExtendMixins,
} from '@/services';
import { EventBus } from '@/event-bus';
import { BankAccounts } from '@/components/account-settings-components/personal-settings-components';
import { PageIntro, PageSidebar } from '@/components/page-components';
import { OpenAddBankAccountScreen } from '@/mixins/get-content-mixins';
import { TokenReAuth } from '@/components/page-components';
import {
  CTA,
  MemberAccountResponseModel,
  MemberBankAccountResponseModel,
  MemberPersonalInformationResponseModel,
} from '@/@types/member';

interface Data {
  sidebarHeading: string;
  sidebarContent: string;
  ctaConfig: CTA;
  tokenModal: boolean;
}

export default ExtendMixins(
  OpenAddBankAccountScreen,
).extend({
  name: 'BankAccountsPage',
  beforeRouteEnter(to, from, next) {
    const promises = [
      getContentArea('bank-accounts-sidebar-content'),
      store.dispatch('getPersonalInformation'),
    ];
    LoadingService.watchPromises(promises)
      .then((data) => {
        const sidebar = data[0];
        if (sidebar && sidebar.fields) {
          to.meta.sidebarHeading = sidebar.fields.headline;
          to.meta.sidebarContent = sidebar.fields.content;
        }
        next();
      })
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  data(): Data {
    return {
      sidebarHeading: this.$route.meta.sidebarHeading,
      sidebarContent: this.$route.meta.sidebarContent,
      ctaConfig: {
        text: '',
        action: () => {},
      },
      tokenModal: false,
    };
  },
  beforeMount() {
    this.ctaConfig = {
      text: this.$options.filters.t([
        'bank-accounts_action_add-bank-account',
      ]),
        action: this.openTokenModal,
    };
  },
  computed: {
    personalInformation(): MemberPersonalInformationResponseModel {
      return this.$store.getters.personalInformation;
    },
    accounts(): MemberAccountResponseModel[] {
      return this.$store.getters.accounts;
    },
    bankAccounts(): MemberBankAccountResponseModel[] {
      return this.$store.getters.bankAccountsSorted;
    },
    hasActiveHSA(): boolean {
      return this.$store.getters.hasActiveHSA;
    },
    showAddBankAccountButton(): boolean {
      return (
        !this.bankAccounts.length ||
        !!(this.bankAccounts.length > 1 && this.hasActiveHSA)
      );
    },
  },
  methods: {
    openTokenModal() {
      this.tokenModal = true;
    },
  },
  components: {
    BankAccounts,
    PageIntro,
    PageSidebar,
    TokenReAuth,
  },
});
